import FJTextStyle from './FJTextStyle';
import FJOutline from './style/FJOutline';

class FJTextStyleDoubleOutline extends FJTextStyle {
    initStyles(props = {}) {
        let textOutline = new FJOutline({
            ...props,
            width: 20,
            widthRef: 1200,
            offset: 0,
            angle: 0,
            textColor: 'transparent',
            position: 'relative',
        });

        let bk = new FJOutline({
            ...props,
            width: 20,
            widthRef: 1200,
            offset: 50,
            angle: 50,
            textColor: 'transparent',
            color: '#01EFFC',
            position: 'absolute',
        });

        this._styles = [bk, textOutline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: [*, *], offset: *, width: *, direction: *}}
     */
    getAdjustInfo() {
        let bk = this._styles[0];
        let outline = this._styles[1];
        return {
            color: [bk.color],
            width: outline.width,
            offset: bk.offset,
            direction: bk.angle,
        };
    }

    /**
     * @desc 获取实际的文字dom对象 <排除样式辅助>
     */
    getActualLayer() {
        if (this._enableStyle) {
            return this._baseStyle.getActualLayer();
        }

        if (!this._styles[1]) return null;

        return this._styles[1].getActualLayer();
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        let bk = this._styles[0];
        let outline = this._styles[1];

        if (info.color[0] !== '') {
            bk.color = info.color[0];
        }
        if (info.width !== '') {
            outline.width = bk.width = info.width;
        }
        if (info.offset !== '') {
            bk.offset = info.offset;
        }
        if (info.direction !== '') {
            bk.angle = info.direction;
        }
    }

    /**
     * @description 设置color
     * @param color
     */
    setColor(color) {
        this._styles[1].color = color;
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach((style, index) => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: index !== this._styles.length - 1 });
        });
    }
}

export default FJTextStyleDoubleOutline;
